import React, { useState, useCallback, useEffect } from 'react';
import { I18nContext } from './i18nContext';
import en from './dictionaries/en';
import fr from './dictionaries/fr';
import {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  isSupportedLanguage,
  applyDocumentLanguage,
} from './languagePreference';

const dictionaries = { en, fr };

export default function I18nProvider({ children, initialLanguage }) {
  const [language, setLanguageState] = useState(initialLanguage || DEFAULT_LANGUAGE);

  const setLanguage = useCallback((lang) => {
    if (isSupportedLanguage(lang)) {
      setLanguageState(lang);
      applyDocumentLanguage(lang);
    }
  }, []);

  useEffect(() => {
    if (initialLanguage && isSupportedLanguage(initialLanguage)) {
      setLanguageState(initialLanguage);
      applyDocumentLanguage(initialLanguage);
    }
  }, [initialLanguage]);

  useEffect(() => {
    applyDocumentLanguage(language);
  }, [language]);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = dictionaries[language];
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return key;
      }
    }
    return typeof value === 'string' ? value : key;
  }, [language]);

  return (
    <I18nContext.Provider value={{
      language,
      setLanguage,
      t,
      supportedLanguages: SUPPORTED_LANGUAGES,
    }}>
      {children}
    </I18nContext.Provider>
  );
}
